import { render, staticRenderFns } from "./pageDialogs.vue?vue&type=template&id=6b648126&scoped=true&lang=pug&"
import script from "./pageDialogs.vue?vue&type=script&setup=true&lang=js&"
export * from "./pageDialogs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./pageDialogs.vue?vue&type=style&index=0&id=6b648126&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b648126",
  null
  
)

export default component.exports